import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Breadcrumb from '../Breadcrumb/Breadcrumb';


const ListLayout = ({  
  breadcrumbItems, 
  children, 
  actionButtons,
  className = ''
}) => {
  return (
    <div className={`d-flex flex-column maindiv ${className}`} style={{flexGrow:'1'}}>
      <div className="d-flex " style={{ backgroundColor: "#fff",flexGrow:'1',flexDirection:'column' }}>
        <div
          className="d-flex justify-content-between align-items-center 
          p-2
          "
          // after complete all pages filter then above p-2 comment and uncomment bellow pading
          
          style={{ background: "#fcfdfe", gap: "5px", width: "100%",
            // padding: "8px 8px 0 8px"
           }}
        >
          <Breadcrumb items={breadcrumbItems} />
          
          <div className="d-flex" style={{ gap: '6px' }}>
            {actionButtons && actionButtons.map((button, index) => (
              <Button
                key={index}
                {...button}
              />
            ))}
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

ListLayout.propTypes = {
  title: PropTypes.string,
  breadcrumbItems: PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string, // optional
  })
).isRequired,
  children: PropTypes.node.isRequired,
  actionButtons: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};

export default ListLayout;